import { Dialog } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyNewUser } from '../../../../shared/proxies/newUserProxy'
import { ErrorBox } from '../../../../shared/components/ui/ErrorBox'
import { PlaceholderBox } from '../../../../shared/components/ui/PlaceholderBox'
import { handleDeleteSubmit, closeDeleteModal } from './utils'

export function DeleteUserModal (): ReactElement {
  const { displayUserDeleteModal, deleteUserApiCall, selectedUser } = useSnapshot(proxyNewUser)

  return (
    <Dialog
      open={displayUserDeleteModal}
      onClose={() => { proxyNewUser.displayUserDeleteModal = false }}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="flex justify-center mt-12">
          <PlaceholderBox loading={false} rows={20} additionalClasses="p-2">
            <form className="bg-white rounded-lg py-6 px-8 border w-full flex flex-col " onSubmit={handleDeleteSubmit}>
              <h3 className="font-medium text-xl mb-4 mx-auto">Delete User Account</h3>
              <div className="text-center">
                Are you sure you want to this user: <br />
                <div className="pt-4 font-bold">{selectedUser?.firstName} {selectedUser?.lastName}</div>
              </div>

              <div className="flex justify-between mt-6">
                <button
                  type="button"
                  className="w-36 flex justify-center py-2 px-4 rounded-md text-sm font-medium text-wpy-blue-500 hover:text-wpy-blue-700 active:bg-wpy-blue-200 focus:outline-none"
                  onClick={closeDeleteModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-48 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-wpy-alert-red-600 hover:bg-wpy-alert-red-500 active:bg-wpy-alert-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-wpy-alert-red-400 disabled:bg-wpy-alert-red-300 disabled:text-gray-200 disabled:hover:bg-wpy-alert-red-300"
                >
                  Confirm
                </button>
              </div>
            </form>
          </PlaceholderBox>
          <ErrorBox error={deleteUserApiCall.error ?? deleteUserApiCall.error} />
        </div>
      </div>
    </Dialog>
  )
}
